import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-20 md:py-32 px-6 bg-sage-light" data-id="element-155">
      <div className="max-w-3xl mx-auto" data-id="element-156">
        <FadeIn data-id="element-157">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-10 text-center" data-id="element-158">
            El peligro de los "lugares seguros"
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-159">
          <FadeIn delay={0.2} data-id="element-160">
            <p data-id="element-161">
              La mayoría de las mujeres de nuestra generación guardan la vida en
              "lugares seguros" que solo ellas conocen. La póliza de seguro en
              una carpeta vieja, la clave del banco en la memoria, y los deseos
              personales guardados en el corazón.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-162">
            <p data-id="element-163">
              Cuando llega un momento crítico, sus hijos no solo enfrentan la
              angustia emocional, sino el caos administrativo: llaves que no
              abren, cuentas bloqueadas y decisiones médicas tomadas a ciegas.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-164">
            <div className="bg-card p-8 rounded-2xl shadow-warm mt-12 border border-sage/10" data-id="element-165">
              <p className="font-serif text-xl md:text-2xl text-sage text-center italic" data-id="element-166">
                Organizar esto no es "atraer a la mala suerte"; es evitar que
                sus seres queridos sufran innecesariamente.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}